// extracted by mini-css-extract-plugin
export default {"userAgreement":"userAgreement_userAgreement__pwxHN","title":"userAgreement_title__OwTz3","content":"userAgreement_content__vIui1"};